import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import ReactECharts from "echarts-for-react";
import { apiRequest } from "../query-configs/widget.js";
import { getApiResult } from "../selectors/widget.js";
import { groupData } from "../jsonStatHelper";

const Graph = ({ module, gid, setTableId, setUpdated }) => {
  module.api.gid = gid;

  const [{ status, isPending }] = useRequest(apiRequest(module.api));
  const apiResult = useSelector((state) => getApiResult(state, gid));
  const [mergedOptions, setMergedOptions] = React.useState(null);

  const { axisLabelFormat } = module;

  useEffect(() => {
    if (apiResult && !mergedOptions && !isPending) {
      let xData = [];
      let response = apiResult.response;
      if (response.dimension[module.api.dimension]) {
        const { index, label } = response.dimension[module.api.dimension].category;
        xData = new Array(Object.keys(index).length);
        for (let key in index) {
          xData[index[key]] = label[key];
        }
        if (module.api.dimension === "BygnType") {
          xData.push(xData.shift());
        }
      }
      const action = module.action || false;
      let label = null;
      if (module.api.showLabel) {
        if (module.api.timeType === "lastYear") {
          label = "Data for periode " + Object.values(response.dimension["Tid"].category.label)[0];
        } else {
          let r = Object.keys(response.dimension["Tid"].category.label);
          label = "Data for periode " + r[0] + " - " + r[r.length - 1];
        }
      }
      let nObj = {
        ...JSON.parse(options),
        title: {
          subtext: label,
          left: "center",
          top: "90%",
          textStyle: {
            fontWeight: "normal",
          },
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            rotate: xData.find((x) => x.length > 10) ? 40 : 0,
          },
        },
        series: [
          {
            data: groupData(response, module.api.dimension, action, module.weighting, module.param),
            type: module.graphType,
            // smooth: true
          },
        ],
      };
      if (axisLabelFormat) {
        if (axisLabelFormat === "percentage") {
          nObj.yAxis.axisLabel = {
            formatter: function (value) {
              return value + "%";
            },
          };
        }
      }
      setMergedOptions(nObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResult]);

  useEffect(() => {
    if (apiResult && mergedOptions && !isPending) {
      if (apiResult.updated) {
        setUpdated(apiResult.updated);
      }
      if (module.api.tableId) {
        setTableId(module.api.tableId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResult, mergedOptions]);

  if (isPending)
    return (
      <div className="spinner">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  if (status !== 200) return <p>Problems loading from external api</p>;
  if (!apiResult) return <p>Mangler data fra SSB</p>;

  if (mergedOptions) {
    return <ReactECharts option={mergedOptions} style={{ marginTop: "40px" }} />;
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 8, right: 8, bottom: 24, left: 30, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  // series: [
  //   {
  //     data: [820, 932, 901, 934, 1290, 1330, 1320],
  //     type: 'line',
  //     smooth: true,
  //   },
  // ],
  tooltip: {
    trigger: "axis",
  },
});
